import React from "react";
import { Modal, Form, Input, Button, Select, DatePicker, Row, Col } from "antd";

const { Option } = Select;

const BookingRequestModal = ({
    isOpen,
    onOk,
    onCancel,
    onSubmit,
    isLoading,
    form,
    getfilteredCountries,
    packageValidity,
    currentDate,
    isExpired
}) => {
    return (

        <Modal
            title="Booking Request"
            open={isOpen}
            style={{ top: 20 }}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={onSubmit}>
                <Form.Item
                    name="name"
                    rules={[{ required: true, message: "Please enter your name" }]}
                >
                    <Input placeholder="Enter Your Full Name" className="form-control rounded" style={{ height: 40 }} />
                </Form.Item>

                <Row gutter={20}>
                    <Col md={12} xs={12}>
                        <Form.Item
                            name="email"
                            rules={[
                                { required: true, message: "Please enter your email" },
                                { type: "email", message: "Please enter a valid email" },
                            ]}
                        >
                            <Input placeholder="Email ID" className="form-control rounded" style={{ height: 40 }} />
                        </Form.Item>
                    </Col>
                    <Col md={12} xs={12}>
                        <Form.Item
                            name="mobile"
                            rules={[
                                { required: true, message: "Please enter your mobile number" },
                                { pattern: /^[0-9]{10}$/, message: "Enter a valid 10-digit number" },
                            ]}
                            normalize={(value) => value && value.toString()}
                        >
                            <Input placeholder="Mobile Number" className="form-control rounded" style={{ height: 40 }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={20}>
                    <Col md={12} xs={12}>
                        <Form.Item
                            name="no_of_adult"
                            rules={[{ required: true, message: "Please select No. of Adults" }]}
                        >
                            <Select
                                showSearch
                                placeholder="No. of Adults"
                                className="form-control p-0 rounded"
                                style={{ height: 40 }}
                            >
                                {Array.from({ length: 9 }, (_, i) => (
                                    <Option key={i + 1} value={i + 1}>{i + 1}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={12} xs={12}>
                        <Form.Item
                            name="no_of_children"
                        >
                            <Select showSearch placeholder="No. of Children" className="form-control p-0 rounded" style={{ height: 40 }}>
                                {Array.from({ length: 9 }, (_, i) => (
                                    <Option key={i} value={i}>{i}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={20}>
                    <Col md={12} xs={12}>
                        <Form.Item
                            name="country"
                            rules={[{ required: true, message: "Please enter your country" }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select a country"
                                optionFilterProp="label"
                                style={{ height: 40 }}
                                options={getfilteredCountries?.map((country) => ({
                                    value: country.name,
                                    label: country.name,
                                }))}
                                className="form-control p-0 rounded"
                            />
                        </Form.Item>
                    </Col>
                    <Col md={12} xs={12}>
                        <Form.Item
                            name="city"
                            rules={[{ required: true, message: "Please enter your city or state" }]}
                        >
                            <Input placeholder="City, State" className="form-control rounded" style={{ height: 40 }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    name="date_of_travel"
                    rules={[{ required: true, message: "Please select travel date" }]}
                >
                    {!isExpired ?
                        <DatePicker
                            style={{ height: 40, width: "100%" }}
                            placeholder="Date of Travel"
                            format="YYYY-MM-DD"
                            disabledDate={(current) =>
                                current && (current.isBefore(currentDate, 'day') || current.isAfter(packageValidity, 'day'))
                            }
                            className="form-control rounded"
                        />
                        :
                        <DatePicker
                            style={{ height: 40, width: "100%" }}
                            placeholder="Date of Travel"
                            format="YYYY-MM-DD"
                            disabledDate={(current) =>
                                current && (current.isBefore(currentDate, 'day'))
                            }
                            className="form-control rounded"
                        />
                    }
                </Form.Item>

                <Form.Item
                    name="message"
                    rules={[{ required: true, message: "Please enter your message" }]}
                >
                    <Input.TextArea rows={2} placeholder="Message" className="form-control rounded" />
                </Form.Item>

                <Form.Item className="mb-0">
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        loading={isLoading}
                        style={{ padding: "0px 55px", height: 45 }}
                        aria-label="send"
                    >
                        {isLoading ? "Sending..." : "Send"}
                    </Button>
                </Form.Item>
                
            </Form>
        </Modal>
    );
};

export default BookingRequestModal;
